import { Fragment } from "react"; 
import { Outlet } from "react-router-dom";


const MktIndexPage = () => {
  return (
    <Fragment>
        <Outlet />
    </Fragment>
  )
}

export default MktIndexPage; 